module.exports = __webpack_public_path__ + "img/management-function-3.6b2ddb9d.png";